"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtensionName = getExtensionName;
exports.isVersionedExtension = isVersionedExtension;
exports.getFileExtension = getFileExtension;
const is_valid_3d_file_type_1 = require("./is-valid-3d-file-type");
// Browser-compatible file utils
const FILE_EXTENSION_REGEX = /(\.[^.]+(?:\.\d+)?)$/;
function getExtensionName(extension) {
    return extension.split('.')[1];
}
function isVersionedExtension(extension) {
    return is_valid_3d_file_type_1.VALID_VERSIONED_EXTENSIONS.has(`.${getExtensionName(extension)}`) && /\.\d+$/.test(extension);
}
function getFileExtension(filename) {
    const match = FILE_EXTENSION_REGEX.exec(filename);
    return match ? match[1] : '';
}
//# sourceMappingURL=file-utils.js.map